<div class="line-chart">
	<canvas #lineChartEl></canvas>
</div>
